<template>
  <el-dialog
    :model-value="modelValue"
    :title="isObsoleta ? 'Atención: ET Obsoleta' : 'Copiar Cotización'"
    width="520px"
    destroy-on-close
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template v-if="habilitarNuevaGrillaCostos">
      <p style="margin-bottom: 12px; font-weight: 600; color: #303133">
        ¿Cómo desea copiar la cotización?
      </p>
      <el-radio-group
        v-model="modoCopia"
        style="display: flex; flex-direction: column; align-items: flex-start; gap: 10px"
      >
        <el-radio value="tecnicos">
          <strong>Copia de datos productivos y porcentajes comerciales</strong>
        </el-radio>
        <el-radio value="costos">
          <strong>Copia idéntica de costos y conceptos</strong>
        </el-radio>
      </el-radio-group>
    </template>

    <div
      v-if="copiaCostos"
      style="margin-top: 15px"
    >
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="Se copiará la grilla de costos tal cual está. Se conservan la versión de ET y las cantidades."
      />
    </div>

    <div
      v-else-if="isObsoleta"
      style="margin-top: 15px"
    >
      <p style="margin-bottom: 15px">
        Esta Cotización fue creada a partir de una ET que actualmente se encuentra obsoleta.
      </p>
      <div style="background-color: #f8f9fa; padding: 15px; border-radius: 4px">
        <p style="font-weight: 600; margin-bottom: 12px; color: #303133">
          ¿Qué versión técnica desea utilizar para la copia?
        </p>
        <el-radio-group
          v-model="opcionET"
          style="display: flex; flex-direction: column; align-items: flex-start; gap: 10px"
        >
          <el-radio label="actualizar">
            <strong>Actualizar a la versión vigente</strong>
          </el-radio>
          <el-radio label="mantener">
            <strong>Mantener la versión obsoleta</strong>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="$emit('update:modelValue', false)">Cancelar</el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          Copiar Cotización
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  computed,
  ref,
  watch,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  isObsoleta: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const opcionET = ref('actualizar');
const modoCopia = ref('tecnicos');
const { habilitarNuevaGrillaCostos } = storeToRefs(useConfiguracionStore());
const copiaCostos = computed(
  () => habilitarNuevaGrillaCostos.value && modoCopia.value === 'costos',
);

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      opcionET.value = 'actualizar';
      modoCopia.value = 'tecnicos';
    }
  },
);

const handleConfirm = () => {
  if (copiaCostos.value) {
    emit('confirm', { modoCopia: 'costos' });
    return;
  }
  emit('confirm', {
    modoCopia: 'tecnicos',
    actualizarET: props.isObsoleta ? opcionET.value === 'actualizar' : false,
  });
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
